import { Icon } from "@material-ui/core";
import React from "react";

import buttonStyles from "Styles/ButtonStyles.scss";
import styles from "./FilterHeader.scss";

interface IProps {
    onClear?: () => void;
}

const FilterHeader: React.FunctionComponent<IProps> = (props: IProps) => (
    <div className={styles.filterHeader}>
        <div className={styles.title}>
            <Icon>filter_list</Icon>
            Filters
        </div>
        {
            props.onClear &&
            <button className={`${styles.btnClear} ${buttonStyles.white} ${buttonStyles.small}`} onClick={props.onClear}>
                <Icon>clear</Icon>
                Clear all
            </button>
        }
    </div>
);

export default FilterHeader;


// WEBPACK FOOTER //
// ./src/Components/Common/FilterBar/FilterHeader/FilterHeader.tsx